/** Shared currency formatting for dashboard components. */
export function formatCurrency(amount: number | null | undefined, currency: string): string {
  if (amount == null) return '—';
  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${currency} ${formatted}`;
}

/** Compact axis label: 12345 -> "12k". */
export function formatAxisTick(value: number, currency: string): string {
  if (Math.abs(value) >= 1000) {
    return `${currency} ${(value / 1000).toFixed(Math.abs(value) >= 10000 ? 0 : 1)}k`;
  }
  return `${currency} ${value}`;
}
